import React, { useEffect, useState } from 'react';
import "/node_modules/bootstrap/dist/css/bootstrap.min.css";
import "/node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import '../../CSS/TablaHerramientas.css'
import { getPermission } from '../../Conexiones/Conexion';
import { BsPlus } from 'react-icons/bs';
import { useNavigate } from "react-router";
import { deleteApi, getApi, postApi, putApi } from '../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningModal, warningToast } from '../../Utils/AlertMessage';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Select from 'react-select';
import Loading from '../../Utils/Loading';

function TablaMaterial() {
    const navigate = useNavigate();
    const idCat=parseInt(sessionStorage.getItem("categoria"));
    const [materiales,setMateriales]=useState([]);
    const [tablaMateriales,setTablaMateriales]=useState([]);
    const [busqueda,setBusqueda] = useState ('');
    const [nombreCate,setNombreCate] = useState ('');
    const [unidades,setUnidades]=useState([]);
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const uri = 'mat/';
    const [isLoading,setIsLoading]=useState(false);

    useEffect (()=>{
        const getMateriales = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,14);
            if(permiso){
                const endpoint = "materials/" + idCat;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setMateriales(res.data[0].materiales)
                        setTablaMateriales(res.data[0].materiales)
                        setNombreCate(res.data[0].categoria)
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getMateriales()
    },[idUsuario,navigate,idCat])

    const getMateriales = async () =>{
        const endpoint = uri + idCat;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setMateriales(res.data)
                setTablaMateriales(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const getUnidades = async () =>{
        const endpoint = 'unidad/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setUnidades(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }

    const filtrar= (textoIngresado) =>{
        var resultadoBusqueda = tablaMateriales.filter((elemento)=> {
            if  (elemento.nombreMat.toString().toLowerCase().includes(textoIngresado.toLowerCase())){  
                return elemento; 
            }
            return resultadoBusqueda
        });
        setMateriales(resultadoBusqueda);
    }

    const regresar = () => {
        navigate('/inicio/Catalogos/Materiales')
    }
    //Eliminar
    const modalEliminar = (id) => {
        warningModal('¿QUIERES ELIMINAR ESTE MATERIAL?')
        .then(async (result)  => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="registro eliminado"){
                        getMateriales();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }

    const [idMaterial,setIdMaterial]=useState('')
    const [nombreMat,setNombreMat]=useState('')
    const [codigo,setCodigo]=useState('')
    const [idUnidad,setidUnidad]=useState('')
    const [unidad,setUnidad]=useState('')
    const [isSaving, setSaving] = useState(false);

    //AGREGAR
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const showAddMat = async () => {
        await getUnidades();
        handleShow();
    }
    const closeAddMat = () =>{
        handleClose()
        setNombreMat('')
        setidUnidad('')
        setCodigo('')
    }
    const handleSelectChange = (event) =>{
        setidUnidad(event.value)
    }

    const store = async (e) =>{
        setSaving(true)
        e.preventDefault()
        if(nombreMat.trim().length === 0 | codigo.trim().length === 0 | idUnidad === ''){
            warningToast('CAMPOS VACIOS','EL CAMPO CODIGO, NOMBRE O UNIDAD ESTAN VACÍO');
        }else{
            const endpoint = uri;
            const data = {nombreMat:nombreMat,idUnidad:idUnidad,idCatMat:idCat,codigoMat:codigo};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    closeAddMat();
                    getMateriales();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false)
    }

    //Editar
    const [showUd, setShowUd] = useState(false);
    const handleCloseUd = () => setShowUd(false);
    const handleShowUd = () => setShowUd(true);
    const closeUpdMat = () =>{
        handleCloseUd()
        setNombreMat('')
        setidUnidad('')
        setCodigo('')
    }
    const showUpdMat = async (idm,cod,nom,idu,nomu) => {
        const id = idm;
        const codigo = cod;
        const nombreM = nom;
        const idUni = idu;
        const nombreU = nomu;
        await getUnidades();
        setIdMaterial(id)
        setCodigo(codigo)
        setNombreMat(nombreM)
        setidUnidad(idUni)
        setUnidad(nombreU)
        handleShowUd()
    }
    const update= async (e) => {
        setSaving(true)
        e.preventDefault()
        if(nombreMat.trim().length === 0 | codigo.trim().length === 0 | idUnidad === ''){
            warningToast('CAMPOS VACIOS','EL CAMPO CODIGO, NOMBRE O UNIDAD ESTAN VACÍO');
        }else{
            const endpoint = uri + idMaterial;
            const data = {nombreMat:nombreMat,idUnidad:idUnidad,codigoMat:codigo}
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro modificado correctamente!"){
                    closeUpdMat();
                    getMateriales();
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false)
    }

    return (
        <div className="tablaHerramientas">
            {
                isLoading ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">{nombreCate}</label>
                    </div>
                    <div className='divboton' >                                                                                             
                        <div className='boton'  style={{display:'flex', justifyContent:'space-between'}}>
                            <button  title='Agregar material' className="btn btn-light btncolor" style={{justifyContent:'center'}} onClick={showAddMat} type="button">
                            <label className="agregar">MATERIAL</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>                    
                        </div>
                    </div>
                    {
                        materiales.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaA">
                                <div className="table tabla">
                                    <table className="table table-hover table-bordered text-uppercase">
                                        <thead className="encabezado">
                                            <tr>
                                                <th > CODIGO </th>
                                                <th > CONCEPTO </th>
                                                <th >UNIDAD</th>
                                                <th >ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            { 
                                                materiales.map( material => {
                                                    return (
                                                        <tr key={material.idMaterial}>
                                                            <td valign="middle">{material.codigoMat}</td>
                                                            <td valign="middle">{material.nombreMat}</td>
                                                            <td valign="middle">{material.nombreUnidad}</td>
                                                            <td>
                                                                <div>
                                                                    <div className="btn iconoH" onClick={() => showUpdMat(material.idMaterial,material.codigoMat,material.nombreMat,material.idUnidad,material.nombreUnidad)} style={{margin:'5px'}}>
                                                                        <span className="bi bi-pen" title="EDITAR"></span>
                                                                    </div>
                                                                    <div className="btn iconoH" style={{margin:'5px'}} onClick={() => modalEliminar(material.idMaterial)}>
                                                                        <span className="bi bi-trash" title="ELIMINAR"></span>
                                                                    </div>                                     
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                    }

                    {/*AGREGAR MATERIAL*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-material">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR MATERIAL</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} onClick={closeAddMat} />
                        </Modal.Header>
                        <form onSubmit={store}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', }}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">CODIGO  <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" onChange={(e)=>setCodigo(e.target.value)}   className="form-control" required  aria-describedby="basic-addon1"/>   
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE   <label title="OBLIGATORIO" className="obligatorio">*</label> </label>
                                    <input type="text" onChange={(e)=>setNombreMat(e.target.value)}   className="form-control" required  aria-describedby="basic-addon1"/>   
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" > unidad <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <Select
                                        classNamePrefix="select"
                                        placeholder="Selecciona un tipo de obra..."
                                        required
                                        options={unidades.map(tip=>({label:tip.nombreUnidad,value:tip.idUnidad}))}
                                        onChange={handleSelectChange}
                                    />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={closeAddMat}>CANCELAR</Button>                                               
                                {isSaving===true?
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>

                    {/*EDITAR MATERIAL*/}
                    <Modal show={showUd} onHide={handleCloseUd} id="modal-editar-material">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR MATERIAL</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} onClick={closeUpdMat} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', }}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">codigo </label>   
                                    <input type="text" className="form-control"  value={codigo} onChange={(e)=>setCodigo(e.target.value)} required aria-describedby="basic-addon1"/>   
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">concepto </label>   
                                    <input type="text" className="form-control" value={nombreMat} onChange={(e)=>setNombreMat(e.target.value)} required aria-describedby="basic-addon1"/>   
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" > unidad <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <Select
                                        defaultValue={{ label: unidad, value: idUnidad }}
                                        required
                                        options={unidades.map(tip=>({label:tip.nombreUnidad,value:tip.idUnidad}))}
                                        onChange={handleSelectChange}
                                    />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={closeUpdMat}>CANCELAR</Button>                                               
                                {isSaving===true?
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default TablaMaterial;